import React from 'react';
import { CardContainer } from '../../shared/components/card';
import { SingleFileUpload } from '../../shared/components/fileUpload';
// ADD NEEDED PROPS

export class DragAndDropDevelopmentPage extends React.Component {
  render(): JSX.Element {
    return (
      <div className='bg-gray-lightest w-full min-h-screen'>
        <div className='w-3/4 mx-auto py-20'>
          <h1>Drag And Drop Development</h1>
          <CardContainer stripPadding={false}>
            {/* Start Drag and Drop Dev Here */}
            <SingleFileUpload label='Upload Profile Image' name='images' />
            {/* End Drag and Drop Dev Here */}
          </CardContainer>
        </div>
      </div>
    );
  }
}
